/**
 * ActivationCreditCardsCtrl controller
 * Show credit cards on activation page
 */

import { CREDIT_CARD_TYPES } from 'app/core/constants'
import { remove } from 'app/helpers/entity'

// controller mixins
ActivationCreditCardsCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * ActivationCreditCardsCtrl controller
 *
 * @class ActivationCreditCardsCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:ActivationCreditCardsCtrl
 */
/* @ngInject */
export default function ActivationCreditCardsCtrl ($uibModal, CreditCard, subscr, scope) {
  var vm = this

  /**
   * Credit card types
   *
   * @memberof mwApp/subscribers.controller:ActivationCreditCardsCtrl
   * @type {Object[]}
   */
  vm.cards_types = CREDIT_CARD_TYPES

  /**
   * Storage types
   *
   * @memberof mwApp/subscribers.controller:ActivationCreditCardsCtrl
   * @type {Object[]}
   */
  vm.storage_types = {
    LOCAL: 'Local System',
    TELR: 'Telr',
    GR4VY_GATEWAY: 'Gr4vy',
    CCPP: '2C2P',
    AIRWALLEX: 'Airwallex'
  }

  // load credit cards
  CreditCard.loadAll({ subscriber: subscr })
    .to(vm.cards = scope.cards = [])

  /**
   * Edit credit card
   *
   * @memberof mwApp/subscribers.controller:ActivationCreditCardsCtrl
   * @function
   * @param  {models.CreditCard} card
   */
  vm.editCreditCard = scope.editCreditCard = null

  /**
   * Create credit card
   *
   * @memberof mwApp/subscribers.controller:ActivationCreditCardsCtrl
   * @function
   * @param  {models.CreditCard} card
   */
  vm.addCreditCard = vm.editCreditCard =
  scope.addCreditCard = scope.editCreditCard = function (card) {
    var isNew = !card
    var initialCard = angular.copy(card) // initial state
    $uibModal.open({
      templateUrl: 'components/subscribers/activation/views/addCreditCard.html',
      controller: 'AddCreditCardCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        card: function () {
          return !isNew
            ? card
            : new CreditCard({ subscriber: subscr })
        }
      }
    }).result
      .then(
        function close (card) {
          if (isNew) {
            vm.cards.push(card)
          }
        },
        function dismiss () {
          if (!isNew) {
            angular.copy(initialCard, card) // restore credit card
          }
        }
      )
  }

  /**
   * Delete credit card
   *
   * @memberof mwApp/subscribers.controller:ActivationCreditCardsCtrl
   * @param  {models.CreditCard} card
   */
  vm.deleteCreditCard =
    scope.deleteCreditCard = function (card) {
      card._delete()
        .then(remove(vm.cards)(card))
    }
}
